module.exports = __webpack_public_path__ + "static/media/new.2718a414.png";


//////////////////
// WEBPACK FOOTER
// ./src/new.png
// module id = 73
// module chunks = 0